import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import DeletionBucketSection from 'app/components/DeletionBucketSection';
import { CustomerLedgerHeader } from 'app/constants/table-header-constants';
import { ParseTableDate } from 'app/utils/Parsers';
import useCustomerLedger from './useCustomerLedger';

const CustomerLedger = ({ latestDeletionDate, latestRestorationDate }) => {
  const {
    pageLoading,

    flatData,
    flatTotal,
    flatPageCount,
    fetchFlat,

    beforeData,
    beforeTotal,
    beforePageCount,
    fetchBefore,

    afterData,
    afterTotal,
    afterPageCount,
    fetchAfter,

    dataPerPage,
  } = useCustomerLedger(latestDeletionDate, latestRestorationDate);

  if (!latestDeletionDate) {
    return (
      <>
        <div className='cms-content__container'>
          <PaginatedTable
            columns={CustomerLedgerHeader}
            data={flatData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={flatTotal}
            pageCount={flatPageCount}
            pageLoading={pageLoading}
            fetchData={fetchFlat}
          />
        </div>
        {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
      </>
    );
  }

  const boundaryFormatted = ParseTableDate(latestDeletionDate);
  const restorationFormatted = latestRestorationDate
    ? ParseTableDate(latestRestorationDate)
    : undefined;
  return (
    <>
      <div className='cms-content__container'>
        <DeletionBucketSection
          title='Account restored'
          captionDate={restorationFormatted}
          captionPrefix='Account restored on'
          isEmpty={afterData.length === 0}
        >
          <PaginatedTable
            columns={CustomerLedgerHeader}
            data={afterData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={afterTotal}
            pageCount={afterPageCount}
            pageLoading={pageLoading}
            fetchData={fetchAfter}
          />
        </DeletionBucketSection>
        <DeletionBucketSection
          title='Account deleted'
          captionDate={boundaryFormatted}
          isEmpty={beforeData.length === 0}
        >
          <PaginatedTable
            columns={CustomerLedgerHeader}
            data={beforeData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={beforeTotal}
            pageCount={beforePageCount}
            pageLoading={pageLoading}
            fetchData={fetchBefore}
          />
        </DeletionBucketSection>
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default CustomerLedger;
